module.exports = __webpack_public_path__ + "img/vip_detail.f64e1245.jpg";